"use client";
import { useEffect, useRef } from "react";
import { getPresenceSocket } from "@/lib/sockets";

export default function usePresence(enabled: boolean) {
  const started = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    const socket = getPresenceSocket();
    const interval = setInterval(() => {
      socket.emit("user:heartbeat");
    }, 25000);

    const handleUnload = () => {
      socket.emit("user:offline");
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      clearInterval(interval);
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [enabled]);
  // useEffect(() => {
  //   if (!enabled || started.current) return;
  //   started.current = true;

  //   const socket = getPresenceSocket();

  //   socket.emit("user:online");

  //   const interval = setInterval(() => {
  //     socket.emit("user:heartbeat");
  //   }, 25000);

  //   const handleUnload = () => {
  //     socket.emit("user:offline");
  //   };

  //   window.addEventListener("beforeunload", handleUnload);

  //   return () => {
  //     socket.emit("user:offline");
  //     clearInterval(interval);
  //     window.removeEventListener("beforeunload", handleUnload);
  //   };
  // }, [enabled]);
}
